(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class ReviewsBadgeLoader extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector(':scope > template');
      if (!this.template) return;

      // Two screens of lead time: the script, then the rating it fetches, should
      // arrive before the badge scrolls into view.
      this.observer = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.observer.disconnect();
        this.load();
      }, { rootMargin: '200% 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    load() {
      // Scripts imported out of a <template> run once inserted.
      const content = document.importNode(this.template.content, true);
      content.querySelectorAll('script[src]').forEach((script) => {
        script.addEventListener('error', () => {
          // Give back the height held for the badge (section-footer.css).
          this.toggleAttribute('data-failed', true);
          console.error(`Reviews badge script failed to load: ${script.src}`);
        });
      });
      this.template.replaceWith(content);
      this.template = null;
    }
  }

  customElements.define('reviews-badge-loader', ReviewsBadgeLoader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
      this.querySelectorAll('mega-menu').forEach((menu) => menu.preloadImages?.());
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      const initialScrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const initialHeaderBounds = this.header.getBoundingClientRect();

      this.headerBounds = {
        top: initialScrollTop + initialHeaderBounds.top,
        bottom: initialScrollTop + initialHeaderBounds.bottom
      };
      this.currentScrollTop = initialScrollTop;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.upwardScrollDistance = 0;
      this.lastScrollDirection = null;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (theme.config.isAppleTouch && (
        document.body.classList.contains('menu-mobile--open')
        || document.body.classList.contains('menu-mobile--opening')
        || document.body.classList.contains('menu-mobile--closing')
        || document.body.classList.contains('mini-cart--open')
        || document.body.classList.contains('mini-cart--opening')
        || document.body.classList.contains('mini-cart--closing')
        || document.body.classList.contains('search-modal--open')
        || document.body.classList.contains('facet-drawer--open')
        || document.body.classList.contains('facet-drawer--opening')
        || document.body.classList.contains('facet-drawer--closing')
      )) {
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const scrollDelta = scrollTop - this.currentScrollTop;
      const scrollNoiseThreshold = theme.config.mqlSmall ? 2 : 0;

      if (!this.atPageTop(scrollTop) && Math.abs(scrollDelta) <= scrollNoiseThreshold) {
        return;
      }

      if (theme.config.mqlSmall) {
        if (this.atPageTop(scrollTop)) {
          this.upwardScrollDistance = 0;
          this.lastScrollDirection = null;
          if (this.header.classList.contains('shopify-section-header-sticky')) {
            this.requestHeaderState('reset');
          }
        }
        else if (!this.sticky()) {
          this.lastScrollDirection = scrollDelta < 0 ? 'up' : 'down';
          this.requestHeaderState('stick');
        }
      }
      else if (this.scrollUpActive) {
        if (this.atPageTop(scrollTop)) {
          this.upwardScrollDistance = 0;
          this.lastScrollDirection = null;
          this.requestHeaderState('reset');
        }
        else if (scrollDelta > 0) {
          this.upwardScrollDistance = 0;
          this.lastScrollDirection = 'down';
          if (scrollTop > this.headerBounds.bottom) {
            this.requestHeaderState('hide');
          }
        }
        else if (scrollDelta < 0) {
          if (this.lastScrollDirection !== 'up') {
            this.upwardScrollDistance = 0;
          }
          this.lastScrollDirection = 'up';

          if (!this.preventReveal) {
            // ignore small upward jitters — only reveal the sticky header
            // after a deliberate upward scroll
            this.upwardScrollDistance += Math.abs(scrollDelta);
            if (scrollTop <= this.headerBounds.bottom || this.upwardScrollDistance > 150 || this.sticky()) {
              this.requestHeaderState('reveal', () => this.lastScrollDirection === 'up' || this.sticky());
            }
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            this.requestHeaderState('hide');
          }
        }
      }
      else {
        if (this.atPageTop(scrollTop)) {
          this.requestHeaderState('reset');
        }
        else {
          this.requestHeaderState('stick');
        }
      }

      this.currentScrollTop = scrollTop;
    }

    requestHeaderState(state, guard) {
      if (this.scrollFrame) cancelAnimationFrame(this.scrollFrame);
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        if (guard && !guard()) return;
        this[state]();
      });
    }

    atPageTop(scrollTop) {
      // Mobile: reset only at the real top. Using the announcement height as
      // the handoff made stick/reset flip around that line and the hero title
      // jumped with it.
      if (theme.config.mqlSmall) {
        return scrollTop <= 1;
      }
      return scrollTop <= this.topHandoffOffset();
    }

    topHandoffOffset() {
      if (!theme.config.mqlSmall) {
        return 0;
      }

      const announcement = document.querySelector('.shopify-section-announcement-bar');
      if (!announcement || announcement.offsetParent === null) {
        return 0;
      }

      return Math.ceil(announcement.getBoundingClientRect().height || announcement.offsetHeight || 0);
    }

    hide() {
      // On mobile, remove the sticky layer entirely instead of translating a
      // hidden fixed/sticky header offscreen. The document header has already
      // scrolled away, so clearing the sticky state makes it disappear without
      // leaving a compositor layer at the Safari edge.
      if (theme.config.mqlSmall) {
        this.reset();
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    // Instant sticky, no translate or top animation. Moving this fixed bar
    // through the screen edge makes Safari paint a white strip there.
    stick() {
      this.header.classList.add('shopify-section-header-sticky');
      this.header.classList.remove('shopify-section-header-hidden', 'animate');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      document.body.classList.remove('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class StickyProductContainer extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.stickyElement = this; // Reference to the sticky element.

      this.stickyBounds = {};
      this.currentScrollTop = 0;
      this.stickyTop = 0;
      this.bottomGap = 40;

      this.onScrollHandler = this.onScroll.bind(this);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.stickyBounds = entries[0].intersectionRect;

        if (this.stickyBounds.top === 0 && this.stickyBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.stickyBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        this.stickyTop = this.stickyBounds.top;
        this.updateStickyElement();
        
        observer.disconnect();
      });

      observer.observe(this);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const screenHeight = window.innerHeight;
      const endScroll = screenHeight - this.stickyElement.offsetHeight - this.bottomGap;
      let stickyElementTop = parseInt(this.stickyElement.style.top.replace(`px`, ``)); 
      // Check if the sticky element exceeds the viewport height.
      if (this.stickyElement.offsetHeight > screenHeight) {
        if (scrollTop < this.currentScrollTop) {
          // Scrolling up
          if (stickyElementTop < this.stickyBounds.top) {
            // Move the sidebar upwards as the user scrolls up.
            this.stickyTop = (stickyElementTop + this.currentScrollTop - scrollTop);
          } else if (stickyElementTop >= this.stickyBounds.top && stickyElementTop != this.stickyBounds.top) {
            // Snap to the top gap if it overshoots.
            this.stickyTop = this.stickyBounds.top;
          }
        } else {
          // Scrolling down
          if (stickyElementTop > endScroll) {
            // Move the sidebar downwards as the user scrolls down.
            this.stickyTop = (stickyElementTop + this.currentScrollTop - scrollTop);
          } else if (stickyElementTop < endScroll && stickyElementTop != endScroll) {
            // Snap to the bottom limit if it overshoots.
            this.stickyTop = endScroll;
          }
        }
      } else {
        // If the sticky element fits within the viewport, keep it at the top gap.
        this.stickyTop = this.stickyBounds.top;
      }

      requestAnimationFrame(this.updateStickyElement.bind(this));

      this.currentScrollTop = scrollTop;
    }

    updateStickyElement() {
      this.stickyElement.style.top = this.stickyTop + `px`;
    }
  }
  customElements.define('sticky-product-container', StickyProductContainer);

  } catch(e) { console.error(e); }
})();
})();
